import './Logged.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Logged = (props) => {

    const navigate = useNavigate();
    const registrar = () => {
        const data = {
            ingreso: true
        }
        axios.post("https://cootransfusa.com/mantenimiento-cootransfusa/", props.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            props.handleDataReceived(response.data)
        })
        .catch(error => {
            console.error(error);
        });
    }

    const revisar = () => {
        const data = {
            revisar: true
        }
        axios.post("https://cootransfusa.com/mantenimiento-cootransfusa/", props.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            props.handleDataReceived(response.data)
        })
        .catch(error => {
            console.error(error);
        });
    }

    function logout() {
        localStorage.setItem("login", false);
        localStorage.setItem("loginStatus", "Sesión cerrada exitosamente");
        //navigate("/");
        window.location.href = "https://cootransfusa.com/mantenimiento/"
    }

    return(
        <>

            <div className='logged'>
                <button type="button" onClick={registrar} className='button_item button_register logged_item'><i className="fa-solid fa-plus logged_register logged_icons"></i>Registrar Nueva Inspección</button>
                <button type="button" onClick={revisar} className='button_item button_review logged_item'><i className="fa-solid fa-magnifying-glass logged_review logged_icons"></i>Revisar Inspecciones registradas</button>
                <button type="button" onClick={logout} className='button_item button_logout logged_item'><i className="fa-solid fa-right-from-bracket fa-rotate-180 logged_logout logged_icons"></i>Cerrar Sesión</button>
            </div>

        </>
    )
}

export default Logged